import { useCrossPlatformRootTag } from '../../shared/context/CrossPlatformRootTagContext';
import { useBridge } from '../../shared/native-modules/BridgeContext';

import { useCallback } from 'react';

export function useHandleStartIndeedApply(): (applyUrl: string) => Promise<string | null> {
    const rootTag = useCrossPlatformRootTag();
    const viewJobNativeModule = useBridge('ViewJobModule');
    return useCallback(
        async (applyUrl: string): Promise<string | null> => {
            const result = await viewJobNativeModule?.handleStartIndeedApply?.(rootTag, applyUrl);
            return typeof result === 'string' ? result : null;
        },
        [rootTag, viewJobNativeModule],
    );
}
